// src/features/auth/components/UserCard.jsx
import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { ChevronRight as ChevronRightIcon } from '@mui/icons-material';
import { capitalizeFirst } from '../../../../../utils/formatters/capitalize';
import ProfilePicture from '../../../../../components/common/ProfilePicture';

export default function UserCard({ user, onSelect }) {
  return (
    <Card
      sx={{
        transition: 'all 0.2s',
        minWidth: '250px',
        flex: '0 1 250px',
        cursor: 'pointer',
        '&:hover': {
          transform: 'translateY(-2px)',
        },
      }}
      onClick={() => onSelect(user)}
    >
      <CardContent sx={{ '&:last-child': { pb: "16px" } }}>
        <Box display="flex" alignItems="center" gap={2}>
          <ProfilePicture
            profilePictureFileId={user?.profile_picture_file_id}
            name={user?.name}
            size={40}
            imageSize="64x64"
            bgcolor="secondary.main"
            color={user?.color}
          />
          <Typography variant="h6" fontWeight="bold" noWrap flex={1}>
            {capitalizeFirst(user.name)}
          </Typography>
          <ChevronRightIcon color="action" />
        </Box>
      </CardContent>
    </Card>
  );
}